/* eslint-disable */
import React, { useCallback } from 'react';
import './index.scss';
import { Button, Dropdown } from 'react-bootstrap';
import ArrowDownLightImg from 'src/assets/images/arrow-down-light.png';
import ArrowDownDarkImg from 'src/assets/images/arrow-down-dark.png';
import useHistory from 'src/hooks/useHistory';
import useSort from 'src/hooks/useSort';
import useTheme from 'src/hooks/useTheme';

const options = {
  new: {
    code: 'new',
    title: 'New',
  },
  popular: {
    code: 'popular',
    title: 'Popular',
  },
  maxWin: {
    code: 'maxWin',
    title: 'Max Win',
  },
  rtp: {
    code: 'rtp',
    title: 'RTP',
  },
};

const GameSort = () => {
  const { theme } = useTheme();
  const isDarkPalette = theme === 'dark';
  const { updateSearchParams } = useHistory();
  const {
    sortBy,
    sortDirection,
    setSortBy,
    setSortDirection,
    sortByKey,
    sortDirectionKey,
  } = useSort();

  const onSortByChange = useCallback(
    (code) => () => {
      updateSearchParams(sortByKey, code);
      setSortBy(code);
    },
    [history, sortByKey],
  );

  const onSortDirectionChange = useCallback(() => {
    const direction = sortDirection === 'asc' ? 'desc' : 'asc';
    updateSearchParams(sortDirectionKey, direction);
    setSortDirection(direction);
  }, [history, sortDirection, sortDirectionKey]);

  return (
    <div className="game-sort-container">
      <Dropdown className="game-sort-switch">
        <Dropdown.Toggle variant="outline">
          {/* <img
            className="icon"
            src={isDarkPalette ? SortLightImg : SortDarkImg}
          /> */}
          <span className={`label label--${isDarkPalette ? 'dark' : 'light'}`}>
            Sort by: <span className="value">{options[sortBy].title}</span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          {Object.values(options).map((x) => (
            <Dropdown.Item
              key={x.code + x.title}
              href={'#'}
              onClick={onSortByChange(x.code)}
              className={`dropdown-item dropdown-item--${
                isDarkPalette ? 'dark' : 'light'
              } ${x.code === sortBy ? 'selected' : ''}`}
            >
              {x.title}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <Button
        className="game-sort-direction"
        variant="link"
        onClick={onSortDirectionChange}
      >
        <img
          className={`icon ${sortDirection === 'asc' ? 'rotate' : ''}`}
          src={isDarkPalette ? ArrowDownLightImg : ArrowDownDarkImg}
        />
      </Button>
    </div>
  );
};

export default GameSort;
